import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NavbarState {
  homeActive: boolean;
  musicActive: boolean;
  worldActive: boolean;
  contactActive: boolean;
}

const initialState: NavbarState  = {
    homeActive: true,
    musicActive: false,
    worldActive: false,
    contactActive: false,
};

const navLinks = createSlice({
  name: 'navLinks',
  initialState,
  reducers: {
    setHomeActive: (state, action: PayloadAction<boolean>) => {
      state.homeActive = action.payload;
      state.musicActive = false;
      state.worldActive = false;
      state.contactActive = false;
    },
    setMusicActive: (state, action: PayloadAction<boolean>) => {
        state.musicActive = action.payload;
        state.homeActive = false;
        state.worldActive = false;
        state.contactActive = false;
    },
    setWorldActive: (state, action: PayloadAction<boolean>) => {
        state.worldActive = action.payload;
        state.homeActive = false;
        state.musicActive = false;
        state.contactActive = false;
    },
    setContactActive: (state, action: PayloadAction<boolean>) => {
        state.contactActive = action.payload;
        state.homeActive = false;
        state.worldActive = false;
        state.musicActive = false;
    },
    setNoneActive: (state, action: PayloadAction<boolean>) => {
      state.contactActive = false;
      state.homeActive = false;
      state.worldActive = false;
      state.musicActive = false;
  },
  },
});

export const { setHomeActive, setMusicActive, setWorldActive , setContactActive, setNoneActive} = navLinks.actions;
const navLinksReducer  = navLinks.reducer
export default navLinksReducer;